import { render, staticRenderFns } from "./oldinf.vue?vue&type=template&id=5cb3b6ac&scoped=true&"
import script from "./oldinf.vue?vue&type=script&lang=js&"
export * from "./oldinf.vue?vue&type=script&lang=js&"
import style0 from "./oldinf.vue?vue&type=style&index=0&id=5cb3b6ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb3b6ac",
  null
  
)

export default component.exports